import { HttpResponse } from "./createEnquiry";

export const removeQuote = async (
  baseUrl: string,
  quoteId: string,
): Promise<HttpResponse> => {
  // deepcode ignore HardcodedNonCryptoSecret
  const accessToken = "access-token";
  const url = `${baseUrl}/trade-in-quote`;
  return await fetch(`${url}/${quoteId}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-api-client-id": "electricals",
      Authorization: `Bearer ${accessToken}`,
      "Jl-Ui-Correlation-Id-V1": generateCorrelationId(),
    },
  })
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && status >= 200 && response.status <= 299) {
        return { status: status, body: response.json() };
      }
      return { status: status, error: "Remove quote failed" };
    })
    .catch(() => {
      return { status: 400, error: "Remove quote failed" };
    });
};

const generateCorrelationId = () => {
  return `ELECTRICALS-${new Date().getTime()}-${Math.random()}`;
};
